import React from 'react';
import PropTypes from 'prop-types';
import Input from '@blaze-react/input';
import { MdSearch } from 'react-icons/md';
import { SEARCH_TERM } from '../constants';

const TextSearch = ({ label, searchValue, updateFilterValues, elementTitle }) => (
  <>
    {elementTitle && <div className="heading heading--section">{elementTitle}</div>}
    <div className="search">
      <div className="search__wrapper">
        <div className="form-field form-field--input form-field--search">
          <Input
            id={SEARCH_TERM}
            value={searchValue}
            placeholder={label || 'Search'}
            onChange={({ value: eValue }) => {
              updateFilterValues({ [SEARCH_TERM]: eValue }, false);
            }}
          />
        </div>
        <button
          type="button"
          className="icon-button icon-button--search"
          aria-label="Search"
          onClick={e => {
            e.preventDefault();
            updateFilterValues({ [SEARCH_TERM]: searchValue }, true);
          }}>
          <i>
            <MdSearch />
          </i>
        </button>
      </div>
    </div>
  </>
);

TextSearch.propTypes = {
  searchValue: PropTypes.string.isRequired,
  updateFilterValues: PropTypes.func.isRequired,
  elementTitle: PropTypes.string,
  label: PropTypes.string
};

TextSearch.defaultProps = {
  elementTitle: '',
  label: ''
};

export default TextSearch;
